export const RESET_STATE_ACTION_TYPE = "@@RESET";
